import axios from 'axios';
import { getApiHeaderNotTime } from '../services/getApiHeaders';

export function generateMFA() {
    const token = localStorage.getItem('temp_token') || localStorage.getItem('access_token');
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/mfa/generate',
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        withCredentials: true
    };
    return axios(options);
}

export function verifyMFA(code, secret = null) {
    const token = localStorage.getItem('temp_token') || localStorage.getItem('access_token');
    const data = { code };
    if (secret) {
        data.secret = secret;
    }

    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/mfa/verify',
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        withCredentials: true,
        data: data
    };
    return axios(options);
}

export function disableMFA() {
    const token = localStorage.getItem('temp_token') || localStorage.getItem('access_token');
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/mfa/disable',
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        withCredentials: true
    };
    return axios(options);
}
 


// WEBPACK FOOTER //
// ./src/utils/mfa.js